import { useDialogs } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Button, ButtonVariant, Dialog, DialogProps, Typography } from '@optimus-web/core';

interface ConfirmationDialogProps extends Pick<DialogProps, 'portalContainerId'> {
    dialogBodyKey: Mews.TextKey;
    dialogTitleKey: Mews.TextKey;
    onClose: (e: React.MouseEvent) => void;
    onConfirm: (e: React.MouseEvent) => void;
    primaryActionKey: Mews.TextKey;
    primaryActionVariant?: ButtonVariant;
}

const ConfirmationDialog = ({
    dialogBodyKey,
    dialogTitleKey,
    onClose,
    onConfirm,
    portalContainerId,
    primaryActionKey,
    primaryActionVariant = 'primary',
}: ConfirmationDialogProps) => (
    <Dialog
        portalContainerId={portalContainerId}
        active
        actions={[
            {
                children: lt(primaryActionKey),
                variant: primaryActionVariant,
                onClick: onConfirm,
                size: 'medium',
                type: 'submit',
            },
        ]}
        footerDetail={
            <Button onClick={onClose} size="medium" type="submit">
                {lt('GoBack')}
            </Button>
        }
        size="small"
        title={lt(dialogTitleKey)}
        onClose={onClose}
    >
        <Typography textStyle="bodyLarge" as="div">
            {lt(dialogBodyKey)}
        </Typography>
    </Dialog>
);

const dialogId = 'sellLimitsDialogId';

type UseSellLimitsConfirmationDialogParams = Omit<ConfirmationDialogProps, 'onClose'> & {
    onClose?: (e: React.MouseEvent) => void;
};

export const useSellLimitsConfirmationDialog = ({
    onClose,
    onConfirm,
    ...other
}: UseSellLimitsConfirmationDialogParams) => {
    const { openDialog, closeDialog } = useDialogs();

    const handleConfirm = (e: React.MouseEvent) => {
        handleClose(e);
        onConfirm(e);
    };
    const handleClose = (e: React.MouseEvent) => {
        closeDialog(dialogId);
        onClose?.(e);
    };

    return () => {
        openDialog(<ConfirmationDialog onConfirm={handleConfirm} onClose={handleClose} {...other} />, dialogId);
    };
};
